import fetch from '@/utils/fetch';
import {systemFetch} from '@/utils/fetch';
//新增积分规则
export function addABCPointRule(args) {   
    return systemFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'abc/point/addABCPointRule',
        method: 'post',
        data: JSON.stringify(args)
    });
}
//编辑积分规则
export function updateABCPointRule(args) {   
    return systemFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'abc/point/updateABCPointRule',
        method: 'post',
        data: JSON.stringify(args)
    });
}
//积分规则分页列表
export function getABCPointRuleForPage(query) {
    let params = new URLSearchParams();
    params.append("pageNo",query.pageNo);
    params.append("pageSize",query.pageSize);
    return systemFetch({
        url: 'abc/point/getABCPointRuleForPage',
        method: 'get',
        params
    });
}
//删除
export function delABCPointRuleById(id) {
    let params = new URLSearchParams();
    params.append("id",id);   
    return systemFetch({
        url: 'abc/point/delABCPointRuleById',
        method: 'get',
        params
    });
}
//详情
export function getABCPointRuleInfo(id) {
    let params = new URLSearchParams();
    params.append("id",id);   
    return systemFetch({
        url: 'abc/point/getABCPointRuleInfo',
        method: 'get',
        params
    });
}


// WEBPACK FOOTER //
// ./src/api/integralrule.js